/**
 * What the screen shows while a write is in flight:
 * - `backdrop` blocks the whole screen, so nothing is tapped twice.
 * - `corner` spins in the top right and leaves the screen usable (autosave).
 * - `none` shows nothing (fire-and-forget tracking).
 */
export type WriteIndicator = 'backdrop' | 'corner' | 'none';

/**
 * The keys `useWrite` gives a write by its indicator, so `useWriteIndicator`
 * can count each kind. No caller sets them: a write asks with `indicator`.
 */
export const CORNER_WRITE_KEY = ['corner-write'] as const;
export const BACKGROUND_WRITE_KEY = ['background-write'] as const;
